import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
  .range-filter {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
    padding-top: ${csSpacing.spacing06};
  }

  .range-filter-inputs {
    align-items: center;
    display: grid;
    gap: ${csSpacing.spacing05};
    grid-template-columns: 1fr auto 1fr;
  }

  .range-filter-buttons {
    align-items: center;
    display: flex;
    gap: ${csSpacing.spacing05};
  }

  .range-filter-clear {
    margin-left: auto;
  }

  .hidden {
    display: none;
  }
`
